export enum TaxTypeEnum {
  Profit = 1,
  Return,
};